import { render, staticRenderFns } from "./DelistedCustomersYTDReport.vue?vue&type=template&id=36a6b10c&"
import script from "./DelistedCustomersYTDReport.vue?vue&type=script&lang=js&"
export * from "./DelistedCustomersYTDReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports